import isEmpty from 'lodash/isEmpty'
import { setUser as initSentryUser } from '@sentry/vue'

import { useMaCore } from '@/composables/maCore'
import { initializeWootric } from '@/base/Wootric'
import MaFullStory from '@/base/MaFullStory'
import MaBeamer from '@/base/MaBeamer'

export function useThirdPartyTools() {
  const { analytics } = useMaCore()

  const initTools = ({ userInfo, impersonation, isMaUser }) => {
    if (!userInfo || !isEmpty(impersonation))
      return
    analytics.resetUser()
    analytics.identifyUser({ userInfo, impersonation })
    initSentryUser({
      email: userInfo.username,
      id: userInfo.userId,
    })
    MaFullStory.initialize({ userInfo, impersonation })
    MaBeamer.initialize({ userInfo, impersonation })
    initializeWootric(userInfo, isMaUser)
  }

  const sendPageTrackViewEvent = (to, from) => {
    analytics.trackPageView(to, from)
  }

  return {
    initTools,
    sendPageTrackViewEvent,
  }
}
